/* src/app/tools-components/cell-boolean/cell-boolean.component.scss */
.value-container {
  background-color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.value-container .checkbox-label {
  display: block;
  transform: translateX(-32px);
  transition: 0.3s ease-in-out;
}
.value-container .custom-control-label::after,
.value-container .custom-control-label::before {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}
.value-container .content {
  padding: 0.875rem 0.875rem;
}
.value-container .insert-value {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: bold;
  color: #155cb4;
  cursor: pointer;
}
.value-container:hover {
  background-color: rgba(114, 114, 127, 0.08);
}
.value-container:hover .input-container .checkbox-label {
  transform: translateY(0);
}
.value-container:hover .input-container .custom-control-label,
.value-container:hover .input-container .custom-control-input {
  cursor: pointer;
}
.value-container:hover .input-container .custom-control-label::after,
.value-container:hover .input-container .custom-control-label::before {
  opacity: 1;
}
.value-container:hover .input-container .custom-control-label {
  color: #2e2e38;
}
.value-container:hover .show {
  opacity: 1;
  cursor: pointer;
}
.show {
  opacity: 0;
  color: #155cb4;
  font-size: 0.625rem;
  line-height: 0.75rem;
  font-weight: 400;
  margin-left: 0.25rem;
  transition-delay: 0.2s;
  transition: 0.2s ease-in-out;
}
.blue {
  background-color: rgba(21, 92, 180, 0.08);
}
.light {
  background-color: #ffffff;
}
.custom-radio .custom-control-label,
.custom-checkbox .custom-control-label {
  padding-left: 0;
}
.custom-radio .custom-control-label::before,
.custom-checkbox .custom-control-label::before {
  left: -2rem;
  z-index: 1;
}
.custom-radio .custom-control-label::after {
  left: -1.75rem;
  z-index: 1;
}
.custom-checkbox .custom-control-label::after {
  left: -2rem;
  z-index: 1;
}
.custom-control {
  display: flex;
  align-items: center;
  padding-left: 2rem;
}
/*# sourceMappingURL=cell-boolean.component.css.map */
